// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"5e52ef2d","79":"256230d3","540":"3087d3a1","545":"5944ac7b","961":"dc457c17"}[chunkId] + ".chunk.js";
};